import { PChatSDK } from '@sscale/pchatsdk';

const ServiceChat = new PChatSDK();

ServiceChat.CUSTOM_EVENTS = {
  DROP_GUESTS: 'drop_guests',
  USER_READY: 'user_ready',
};

export { ServiceChat };
